module.exports = __webpack_public_path__ + "img/dashboard_estudiante.8618776a.png";